//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

class LoginRequiredException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LoginRequired'; // Set the error name
  }
}

export default LoginRequiredException;
